//const API_BASE_URL = "http://127.0.0.1:8000/api";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class CompaniesHouseService {
  getAuthHeaders() {
    const token = localStorage.getItem('authToken'); // or sessionStorage, depending on your setup
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
    };
  }

  async searchCompanies(query) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/companies-house/search?query=${encodeURIComponent(query)}`,
        {
          method: 'GET',
          headers: this.getAuthHeaders(),
        }
      );
      
      if (!response.ok) {
        if (response.status === 401) {
          // Token might be expired, redirect to login
          this.handleUnauthorized();
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error searching companies:", error);
      throw error;
    }
  }

  async getCompanyDetails(companyNumber) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/companies-house/company/${encodeURIComponent(companyNumber)}`,
        {
          method: 'GET',
          headers: this.getAuthHeaders(),
        }
      );
      
      if (!response.ok) {
        if (response.status === 401) {
          this.handleUnauthorized();
          return;
        }
        if (response.status === 404) {
          throw new Error("Company not found");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching company details:", error);
      throw error;
    }
  }

  handleUnauthorized() {
    // Clear stored token and redirect to login
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('authToken');
    window.location.href = '/login'; // Adjust based on your routing
  }

  // Helper method to check if user is authenticated
  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }
}

const companiesHouseService = new CompaniesHouseService();
export default companiesHouseService;